import { render, staticRenderFns } from "./SkindexSkinCard.vue?vue&type=template&id=936002f2&scoped=true&"
import script from "./SkindexSkinCard.vue?vue&type=script&lang=js&"
export * from "./SkindexSkinCard.vue?vue&type=script&lang=js&"
import style0 from "./SkindexSkinCard.vue?vue&type=style&index=0&id=936002f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936002f2",
  null
  
)

export default component.exports